<template>
  <div class="commissionRateCell fz-13">
    <span>{{ row.commission_rate }}%</span>
    <div class="ad-text" v-if="$isDy(row.platform_id) && row.commission_rate_during_the && row.commission_rate_during_the!= 0">
      <span class="mr-6">投放期</span>
      <span>{{ row.commission_rate_during_the }}%</span>
    </div>
  </div>
</template>
<script>
import mixin from '../../../../../components/tableCells/mixin';
export default {
  mixins: [mixin]
}
</script>
<style scoped>
  .ad-text {
    font-size: 12px;
    color: #FF4F4F;
    white-space: nowrap;
  }
</style>
